export default __webpack_public_path__ + "static/media/l.692d7883.jpg";